import { useEffect } from "react";
// project imports
import { GuardProps } from "shared/types";
import { useAuth } from "shared/hooks/useAuth";

const AuthGuard = ({ children }: GuardProps) => {
  const { hydrate } = useAuth();

  useEffect(() => {
    hydrate();
  }, [hydrate]);

  return children;
};

export default AuthGuard;
